import { render } from "./ClearUpEdit.vue?vue&type=template&id=a36e1b30"
import script from "./ClearUpEdit.vue?vue&type=script&lang=js"
export * from "./ClearUpEdit.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__